import React, { useState } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import ProjectsMockup from './index';
import { EProjectsMockupsTab } from './ProjectsMockupTabs';
import MockupViewRoutes from './ProjectsMockupTabs/Mockups/MockupView/mockupView.routes';
import ProjectHistory from './ProjectsMockupTabs/Projects/ProjectsTable/ViewOptionsButton/ProjectHistory';

export enum EProjectsMockupsRoutes {
  MOCKUP_VIEW = '/mockup-view',
  PROJECT_HISTORY = '/project-history'
}

const ProjectsAndMockupsRoutes: React.FC = () => {
  const { path } = useRouteMatch();
  const [selectedTab, setSelectedTab] = useState(EProjectsMockupsTab.MOCKUPS);

  return (
    <>
      <Route
        path={`${path}`}
        exact
        render={() => (
          <ProjectsMockup
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        )}
      />

      <Route
        path={`${path}${EProjectsMockupsRoutes.MOCKUP_VIEW}`}
        component={MockupViewRoutes}
      />

      <Route
        path={`${path}${EProjectsMockupsRoutes.PROJECT_HISTORY}`}
        render={() => <ProjectHistory setSelectedTab={setSelectedTab} />}
      />
    </>
  );
};

export default ProjectsAndMockupsRoutes;
